"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buttonSizes = exports.variants = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var AnalyticsContext_1 = __importDefault(require("../context/AnalyticsContext"));
var colors_1 = require("../style/colors");
var Spinner_1 = __importDefault(require("./Spinner"));
exports.variants = {
    PRIMARY: {
        backgroundColor: colors_1.oldEpsyColors.primary.purple,
        hoverBackgroundColor: colors_1.oldEpsyColors.secondary.indigo,
        textColor: colors_1.oldEpsyColors.shade.white
    },
    WHITE: {
        backgroundColor: colors_1.oldEpsyColors.shade.white,
        hoverBackgroundColor: colors_1.oldEpsyColors.shade.white,
        textColor: colors_1.oldEpsyColors.primary.purple
    },
    TRANSPARENT: {
        backgroundColor: "rgba(0,0,0,0)",
        hoverBackgroundColor: "rgba(0,0,0,0)",
        textColor: colors_1.oldEpsyColors.primary.purple
    },
    GRAY: {
        backgroundColor: colors_1.oldEpsyColors.shade[3],
        hoverBackgroundColor: colors_1.oldEpsyColors.shade[3],
        textColor: colors_1.oldEpsyColors.shade.white
    },
    PINK: {
        backgroundColor: colors_1.oldEpsyColors.primary.pink,
        hoverBackgroundColor: "#D40080",
        textColor: colors_1.oldEpsyColors.shade.white
    }
};
exports.buttonSizes = {
    LABEL: {
        fontSize: 14,
        lineHeight: 20,
        buttonHeight: 28,
        borderWidth: 1
    },
    SM: {
        fontSize: 14,
        lineHeight: 20,
        buttonHeight: 36,
        borderWidth: 2
    },
    MD: {
        fontSize: 18,
        lineHeight: 28,
        buttonHeight: 40,
        borderWidth: 2
    },
    LG: {
        fontSize: 18,
        lineHeight: 28,
        buttonHeight: 56,
        borderWidth: 2
    },
    XL: {
        fontSize: 18,
        lineHeight: 28,
        buttonHeight: 72,
        borderWidth: 2
    }
};
var RootComp = function (props) {
    var onClick = props.onClick, children = props.children, className = props.className, type = props.type, disabled = props.disabled;
    var commonProps = { onClick: onClick, children: children, className: className, type: type };
    return react_1.default.createElement("button", __assign({}, commonProps, { disabled: disabled }));
};
var Base = (0, styled_components_1.default)(RootComp)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  appearance: none;\n  align-items: center;\n  display: inline-flex;\n  flex-direction: row;\n  font-weight: bold;\n  font-family: inherit;\n  justify-content: center;\n  cursor: pointer;\n  text-decoration: none;\n  position: relative;\n  padding: 0;\n  overflow: hidden;\n  ", "\n"], ["\n  appearance: none;\n  align-items: center;\n  display: inline-flex;\n  flex-direction: row;\n  font-weight: bold;\n  font-family: inherit;\n  justify-content: center;\n  cursor: pointer;\n  text-decoration: none;\n  position: relative;\n  padding: 0;\n  overflow: hidden;\n  ", "\n"])), function (props) { return "\n  transition: background-color 0.4s linear, border-color 0.4s linear, color 0.4s linear;\n  background-color: ".concat(props.backgroundColor, ";\n  color: ").concat(props.textColor, ";\n  border: ").concat(props.borderWidth, "px solid ").concat(props.outlined ? props.textColor : props.backgroundColor, ";\n  border-radius: ").concat(props.buttonHeight * 0.5, "px;\n  font-size: ").concat(props.fontSize, "px;\n  line-height: ").concat(props.lineHeight, "px;\n  height: ").concat(props.buttonHeight, "px;\n  ").concat(props.hasText ? "padding: 0 ".concat(0.6 * props.buttonHeight, "px;") : "", "\n  ").concat(props.hasIcon ? "padding-".concat(props.iconSide, ": 0;") : "", "\n  min-width: ").concat(props.buttonHeight, "px;\n  ").concat(props.fullWidth ? "width: 100%;" : "", "\n  ").concat(props.width ? "width: ".concat(props.width, "px;") : "", "\n  &:hover {\n    background-color: ").concat(props.hoverBackgroundColor, ";\n    ").concat(props.outlined ? "" : "border-color: ".concat(props.hoverBackgroundColor, ";"), "\n  }\n  "); });
var Label = styled_components_1.default.span(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
var IconWrapper = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: relative;\n  ", "\n"], ["\n  position: relative;\n  ", "\n"
    // const spinnerSize = 20
    // const spinnerLeftPadding = 12
])), function (props) {
    var _a = exports.buttonSizes[props.size], buttonHeight = _a.buttonHeight, borderWidth = _a.borderWidth;
    var wrapperSize = buttonHeight - 2 * borderWidth;
    return "\n  height: ".concat(wrapperSize, "px;\n  width: ").concat(wrapperSize, "px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  ");
});
// const spinnerSize = 20
// const spinnerLeftPadding = 12
var spinnerSizeConfig = {
    XL: 20,
    LG: 20,
    MD: 20,
    SM: 18,
    LABEL: 16
};
var spinnerLeftPaddingConfig = {
    XL: 12,
    LG: 12,
    MD: 8,
    SM: 8,
    LABEL: 8
};
var SpinnerWrapper = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (props) {
    var spinnerLeftPadding = spinnerLeftPaddingConfig[props.size];
    var spinnerSize = spinnerSizeConfig[props.size];
    return "\n  height: ".concat(spinnerSize, "px;\n  display: inline-block;\n  min-width: 0;\n  vertical-align: bottom;\n  transition: width 0.2s, opacity 0.5s;\n\n  ").concat(props.isSubmitting
        ? "\n  width: ".concat(spinnerLeftPadding + spinnerSize, "px;\n  opacity: 1;")
        : "\n  opacity: 0;\n  width: 0;", "\n\n  & > div {\n    height: ").concat(spinnerSize, "px;\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    padding-left: ").concat(spinnerLeftPadding, "px;\n  }\n    ");
});
var Button = function (props) {
    var children = props.children, className = props.className, _a = props.label, label = _a === void 0 ? "" : _a, onClick = props.onClick, outlined = props.outlined, _b = props.size, size = _b === void 0 ? "SM" : _b, _c = props.variant, variant = _c === void 0 ? "PRIMARY" : _c, type = props.type, fullWidth = props.fullWidth, isSubmitting = props.isSubmitting, width = props.width, icon = props.icon, _d = props.iconSide, iconSide = _d === void 0 ? "left" : _d, disabled = props.disabled, trackEvent = props.trackEvent, trackData = props.trackData;
    var track = react_1.default.useContext(AnalyticsContext_1.default).track;
    var buttonText = label || children || "";
    var handleClick = onClick;
    if (trackEvent) {
        handleClick = function (evt) {
            if (onClick)
                onClick(evt);
            track(trackEvent, trackData);
        };
    }
    var baseProps = __assign(__assign(__assign({}, exports.buttonSizes[size]), exports.variants[variant]), { className: className, onClick: handleClick, outlined: outlined, type: type, fullWidth: fullWidth, width: width, hasIcon: !!icon, iconSide: iconSide, hasText: !!buttonText, disabled: disabled });
    var iconEl = icon ? react_1.default.createElement(IconWrapper, { size: size, children: icon }) : null;
    return (react_1.default.createElement(Base, __assign({}, baseProps),
        iconSide === "left" ? iconEl : null,
        react_1.default.createElement(Label, null, buttonText),
        react_1.default.createElement(SpinnerWrapper, { isSubmitting: isSubmitting, size: size },
            react_1.default.createElement("div", null,
                react_1.default.createElement(Spinner_1.default, { size: spinnerSizeConfig[size], color: exports.variants[variant].textColor }))),
        iconSide === "right" ? iconEl : null));
};
exports.default = Button;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
